import { useState } from 'react'
import { CardCanvas } from '@/components/CardCanvas'
import { ControlPanel } from '@/components/ControlPanel'
import { Header } from '@/components/Header'

export default function App() {
  const [cardData, setCardData] = useState({
    name: 'Strike',
    energyCost: 1,
    description: 'Deal 6 damage.',
    type: 'Attack',
    color: 'Red',
    rarity: 'Common',
    upgraded: false,
    artwork: null,
    currentSide: 'front'
  })

  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <Header />

      {/* Main Layout */}
      <div className="container mx-auto flex gap-6 py-6 px-4">
        {/* Control Panel */}
        <aside className="w-full lg:w-[360px] shrink-0">
          <ControlPanel cardData={cardData} setCardData={setCardData} />
        </aside>

        {/* 3D Viewport */}
        <main className="flex-1 min-w-0">
          <CardCanvas cardData={cardData} />
        </main>
      </div>
    </div>
  )
}
